import { V3SkuGroupsDataSourceService } from './../data-sources/v3/sku-groups-data-source.service';
import { V3GroundPositionsDataSourceService } from './../data-sources/v3/ground-positions/ground-positions-data-source.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(
    private groundPositionService: V3GroundPositionsDataSourceService,
    private skuGroupsService: V3SkuGroupsDataSourceService
  ) { }

  search(label: string, term: string): Observable<string[]> {
    switch (label) {
      case "Setor":
        return this.groundPositionService.searchGroundPositionGroup(term);
      case "Sku":
        return this.skuGroupsService.searchSkuGroups(term);
      case "Nível":
        return this.groundPositionService.searchLevels(term);
      case "Posição":
        return this.groundPositionService.searchGroundPositionAlias(term);
    }
  }
}
